jQuery(document).ready(function(){
    initModal();
    initMatchHeight();
    initScrollToTop();
    initSimpleLightbox();
    initContentToggle();
    initAdToggle();
    initslider();
    initNavigation();
    initFitVids();
});
function initModal() {
    jQuery(".open-modal").on('click', function () {
        jQuery(".modal").show();
    });
    jQuery(".cancel-modal").on('click', function () {
        jQuery(".modal").hide();
    });
    jQuery(".modal").on('click', function () {
        jQuery(".modal").hide();
    });
    jQuery('.form').click(function(e){
        e.stopPropagation();
    });

}
function initMatchHeight() {
    jQuery('.news-details .p-name').matchHeight();
    jQuery('.news-details .p-summery').matchHeight();
    jQuery('.footer-widgets .widget').matchHeight();
}

function initScrollToTop() {
    let back_to_top_button = ['<a href="#top" class="back-to-top"><i class="icon-angle-up"></i></a>'].join("");
    jQuery("body").append(back_to_top_button)

    // Der Button wird ausgeblendet
    jQuery(".back-to-top").hide();

    // Funktion für das Scroll-Verhalten
    jQuery(function () {
        jQuery(window).scroll(function () {
            if (jQuery(this).scrollTop() > 100) { // Wenn 100 Pixel gescrolled wurde
                jQuery('.back-to-top').fadeIn();
            } else {
                jQuery('.back-to-top').fadeOut();
            }
        });

        jQuery('.back-to-top').click(function () { // Klick auf den Button
            jQuery('body,html').animate({
                scrollTop: 0
            }, 800);
            return false;
        });
    });
}

function initSimpleLightbox() {
    jQuery(function() {
        new SimpleLightbox('.gallery a');
        new SimpleLightbox('.ngg-galleryoverview a');
        new SimpleLightbox('.woocommerce-product-gallery a');
    });
}

function initContentToggle() {
    jQuery(".info-toggle-button").click(function(){
        let toggleButton = jQuery('.info-toggle .info-toggle-button');
        let toggleContent = jQuery(".info-toggle-content");

        if ( toggleContent.css('display') !== 'block') {
            toggleButton.find('.info-toggle-text-collapsed').hide();
            toggleButton.find('.info-toggle-text-expanded').removeClass('hidden');
        } else {
            toggleButton.find('.info-toggle-text-collapsed').show();
            toggleButton.find('.info-toggle-text-expanded').addClass('hidden');
        }

        toggleContent.slideToggle("slow");
    });
};


function initAdToggle() {
    // display with delay
    jQuery("#ad-toggle").delay(2000).fadeIn(500);

    // if cookie is set
    if ( Cookies.set('ad-seera') == 'yes' ) {
        //alert("Cookie gesetzt!");

        jQuery('.ad-toggle-content').hide();
        jQuery('.ad-toggle-text-collapsed').show();
        jQuery('.ad-toggle-text-expanded').addClass('hidden');

        // when click the "Toogle" icon show content
        jQuery(".ad-toggle-button").click(function(){
            let toggleButton = jQuery('#ad-toggle .ad-toggle-button');
            let toggleContent = jQuery(".ad-toggle-content");
            if ( toggleContent.css('display') !== 'none') {
                toggleButton.find('.ad-toggle-text-collapsed').show();
                toggleButton.find('.ad-toggle-text-expanded').addClass('hidden');
            } else {
                toggleButton.find('.ad-toggle-text-collapsed').hide();
                toggleButton.find('.ad-toggle-text-expanded').removeClass('hidden');
            }
            toggleContent.slideToggle("slow");
        });

    // if cookie is not set
    } else {

        //alert("Cookie NICHT gesetzt!");

        // when click the "Toogle" icon hide content
        jQuery(".ad-toggle-button").click(function(){
            let toggleButton = jQuery('#ad-toggle .ad-toggle-button');
            let toggleContent = jQuery(".ad-toggle-content");
            if ( toggleContent.css('display') !== 'block') {
                toggleButton.find('.ad-toggle-text-collapsed').hide();
                toggleButton.find('.ad-toggle-text-expanded').removeClass('hidden');
            } else {
                toggleButton.find('.ad-toggle-text-collapsed').show();
                toggleButton.find('.ad-toggle-text-expanded').addClass('hidden');
            }
            toggleContent.slideToggle("slow");
            Cookies.set('ad-seera', 'yes', { expires: 7, secure: true });
        });
    }

}


function initNavigation() {
    jQuery("#navigation").navigation();
}

function initFitVids() {
    jQuery(".site-content").fitVids();
}

function initslider() {
    jQuery('.greeting_slider').slick({
        dots: false,
        infinite: true,
        arrows: false,
        speed: 300,
        autoplay: true,
    });
}